import { useState } from 'react';
import { Formik } from 'formik';
import Header from '../common/Header/Header';
import httpheader from 'src/Admin/shared/httpheader';
import { Col, Form, Row } from 'react-bootstrap';
import EnableSelfUnlock from './EnableSelfUnlock';
import EligiblePersonas from './EligiblePersonas';
import OTP from './opt';
import UnlockAttempts from './UnlockAttempts';
import CoolOffPeriod from './CoolOffPeriod';
import ForcePassword from './ForcePassword';
import Disclaimer from './Disclaimer';
import IdentificationFields from './IdentificationFields';
import './SelfAccountUnlock.scss';
import useSelfAccountUnlock from './hooks/useSelfAccountUnlock';
import GenericButton from 'src/Components/GenericButton/GenericButton';
import EnrollmentRulesSkeleton from '../Enrollment/components/eligibility-relationship/EnrollmentRulesSkeleton';
import CustomClientError from 'src/Admin/errorhandling/CustomClientError';
import RecentActivityModal from '../PermissionGroups/EnumerationAuditLog/RecentActivityModal';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import MasterPermissions from '../../api/MasterPermissions';

const SelfAccountUnlock = () => {
  const {
    SelfAccountUnlockFormFields,
    initialFormData,
    schema,
    isLoading,
    isServerError,
    saveData,
  } = useSelfAccountUnlock();
  const navigate = useNavigate();
  //const subDomain = httpheader.getSubDomainName();
  //const prefix = subDomain != '' ? '/' + subDomain + '/' : '/';
  const { userData = {} } = useSelector((state) => state.user || {});
  const { SuperUser = false } = userData || {};
  const [showRecentActivityModal, setShowRecentActivityModal] = useState(false);

  const handleAuditButtonClick = (item) => {
    if (item === 'viewAllActivities') {
      navigate(`/admin/enumeration-audit`);
    } else {
      setShowRecentActivityModal(true);
    }
  };

  return (
    <div className="self-account-unlock-wrapper pl-3">
      <div className="container-fuild">
        <Header
          linkTo={`/admin/admin-dashboard`}
          header={'Unlock Account Setup'}
          className="enrollrules-header"
          handleAuditButtonClick={handleAuditButtonClick}
          viewAuditLogButton={
            !!MasterPermissions.CheckPermission('View Audit History')
          }
          auditHistoryLink={true}
          SuperUser={SuperUser}
        />
        {isLoading ? (
          <EnrollmentRulesSkeleton />
        ) : isServerError ? (
          <CustomClientError
            ErrorHeading="Something went wrong with request!"
            ErrorMessage="Please try again."
            CustomClasses="p-0"
          />
        ) : (
          <div className="formik-container">
            <Formik
              enableReinitialize
              initialValues={initialFormData}
              validationSchema={schema}
              onSubmit={async (values, errors) => {
                console.log('working');
                console.log('after submit:', {
                  values: values,
                  errors: errors,
                });
                saveData(values);
              }}
            >
              {({
                handleSubmit,
                handleChange,
                handleBlur,
                values,
                errors,
                touched,
                isValid,
                setFieldValue,
              }) => (
                <div className="form-container mt-4">
                  <Form onSubmit={handleSubmit}>
                    <EnableSelfUnlock
                      values={values}
                      setFieldValue={setFieldValue}
                    />
                    <EligiblePersonas
                      values={values}
                      setFieldValue={setFieldValue}
                    />
                    <OTP values={values} setFieldValue={setFieldValue} />
                    <UnlockAttempts
                      values={values}
                      setFieldValue={setFieldValue}
                      errors={errors}
                      touched={touched}
                    />
                    <CoolOffPeriod
                      values={values}
                      setFieldValue={setFieldValue}
                      errors={errors}
                      touched={touched}
                    />
                    <ForcePassword
                      values={values}
                      setFieldValue={setFieldValue}
                    />
                    <Disclaimer values={values} setFieldValue={setFieldValue} />
                    <IdentificationFields
                      SelfAccountUnlockFormFields={SelfAccountUnlockFormFields}
                      values={values}
                      setFieldValue={setFieldValue}
                    />
                    <Row className="Payment-details border-bottom-0">
                      <Col className="float-right text-right">
                        <GenericButton
                          type="submit"
                          //disable={SavingRegSetup || !editReg}
                          postLabel="SAVE"
                          //onClick={handleSubmit}
                          //buttonDisabled={!editReg}
                          //disable={isDisabledSaveButton}
                          //buttonDisabled={isDisabledSaveButton}
                        >
                          SAVE
                        </GenericButton>
                      </Col>
                    </Row>
                  </Form>
                </div>
              )}
            </Formik>
          </div>
        )}
      </div>
      {showRecentActivityModal && (
        <RecentActivityModal
          show={true}
          onClose={() => setShowRecentActivityModal(false)}
          modalTitle={'Recent Activites'}
        />
      )}
    </div>
  );
};

export default SelfAccountUnlock;
